import axios from "axios";
import {baseUrlIdeal} from "../../config/api/apiConfig";

class IdealChatServices {
    private axios = axios.create({
        baseURL: baseUrlIdeal,
    });

    public async getChatHistory(params?: any) {
        try {
            return await this.axios.get<any>(`/api/get-messages?phoneNumber=${params.phoneNumber}`, {
                headers: {
                    "X-Api-Key": "",
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getDataCustomer(params?: any) {
        try {
            return await this.axios.get<any>(`/api/data-by-phone-number?phoneNumber=${params.phoneNumber}`, {
                headers: {
                    "X-Api-Key": "",
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getMessageOrderConfirm(params?: any) {
        let stringPhoneNumber = "?";
        let i = 0;
        for (const element of params?.phoneNumber) {
            if (i === 0) {
                stringPhoneNumber += `phoneNumber[]=${element}`;
            } else {
                stringPhoneNumber += `&phoneNumber[]=${element}`;
            }
            i++;
        }

        try {
            return await this.axios.get<any>(`/api/get-message-order-confirm${stringPhoneNumber}`, {
                headers: {
                    "X-Api-Key": "",
                }
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }
}

export const idealChatServices = new IdealChatServices();
